import fetcher from '../../modules/ajio-fetch';
import properties from '../../modules/ajio-util/properties';
import { showLoader, hideLoader } from '../../actions/shared/loader';
import { setErrorObject } from '../../actions/shared/HTTPError';
import {
  errorParser,
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode
} from '../../modules/ajio-fetch/utils';
import { addScript, getCart } from './cart';
import getEncryptedData from '../../utils/encryption';

export function setGSTCartDetails(gstCartDetails = {}) {
  return {
    type: 'SET_GST_CART_DETAILS',
    gstCartDetails
  };
}

export function setGSTSavedProfiles(gstSavedProfiles = []) {
  return {
    type: 'SET_GST_SAVED_PROFILES',
    gstSavedProfiles
  };
}

/* CART APIs Actions */

export function validateGSTCart(payload = {}, cb) {
  const { gstNumber = '', businessName = '', address = {} } = payload;
  const requestBody = { gstNumber, businessName, address };

  return dispatch => {
    const apiEndPoint = '/api/cart/gst/validate';
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(requestBody)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        cb?.(response);

        if (response?.valid) {
          dispatch(showLoader('cart-loader'));
          dispatch(
            getCart({ isRequestOrginIsBrowser: true }, () => {
              dispatch(hideLoader('cart-loader'));
            })
          );
          dispatch(getGSTSavedProfiles({ reqOriginNode: false }));
        }
      })
      .catch(error => {
        dispatch(hideLoader('cart-loader'));
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          cb?.(errorObj?.errorMessage);
        });
      });
  };
}

export function detachGSTCart(cb) {
  return dispatch => {
    // dispatch(showLoader('cart-loader'));
    const apiEndPoint = '/api/cart/gst/detach';
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'DELETE',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        // dispatch(hideLoader('cart-loader'));
        cb?.(response);

        dispatch(getCart({ isRequestOrginIsBrowser: true }));
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          cb?.(errorObj?.errorMessage);
        });
      });
  };
}

export function verifyGSTPANCart(payload = {}, cb) {
  const {
    gstId = '',
    businessName = '',
    panNumber = '',
    dateOfIncorporation = '',
    encryptionKey,
    version
  } = payload;

  const requestBody = {
    gstId,
    businessName,
    pan: panNumber,
    dateOfIncorporation
  };

  return async dispatch => {
    dispatch(showLoader('cart-loader'));

    try {
      await addScript('https://unpkg.com/node-forge@0.7.0/dist/forge.min.js');
    } catch (error) {
      console.error('Error loading script:', error);
      dispatch(hideLoader('cart-loader'));
      return;
    }

    try {
      if (encryptionKey && window.forge) {
        // GST PAN number encryption
        requestBody.businessName = getEncryptedData(
          encryptionKey,
          requestBody.businessName,
          version
        );
        requestBody.pan = getEncryptedData(encryptionKey, requestBody.pan, version);
        requestBody.dateOfIncorporation = getEncryptedData(
          encryptionKey,
          requestBody.dateOfIncorporation,
          version
        );
      } else {
        requestBody.businessName = '';
        requestBody.pan = '';
        requestBody.dateOfIncorporation = '';
      }
    } catch (error) {
      console.error('Error encrypting data:', error);
      dispatch(hideLoader('cart-loader'));
      return;
    }

    const apiEndPoint = '/api/cart/gst/verifyPan';
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(requestBody)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader('cart-loader'));
        return cb?.(response);
      })
      .catch(error => {
        dispatch(hideLoader('cart-loader'));
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          cb?.(errorObj?.errorMessage);
        });
      });
  };
}

/* UAAS APIs Actions */

export function validateGSTUAAS(payload = {}, cb) {
  const { gstNumber = '', businessName = '' } = payload;

  const requestBody = { gstNumber, businessName };

  return dispatch => {
    const apiEndPoint = '/api/cart/validateGst';
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(requestBody)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        return cb?.(response);
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          cb?.(errorObj?.errorMessage);
        });
      });
  };
}

// TODO-GST remove this api, as cart will call internally, not for ui
export function validateGSTAddressUAAS(payload = {}, cb) {
  const { gstNumber = '', businessName = '', address = {} } = payload;
  const requestBody = { gstNumber, businessName, address };

  return dispatch => {
    const apiEndPoint = '/api/cart/validateGstAddress';
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(requestBody)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        return cb?.(response);
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          cb?.(errorObj?.errorMessage);
        });
      });
  };
}

export function getGSTSavedProfiles({ reqOriginNode = false, req = {} } = {}, cb) {
  return dispatch => {
    dispatch(showLoader('cart-loader'));
    const apiEndPoint = reqOriginNode
      ? `${properties.getProperty('apiUrl')}/api/cart/gstProfiles` // for testing locally use parentUrl
      : '/api/cart/gstProfiles';

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        ...(reqOriginNode && { body: JSON.stringify({ token: req?.cookies?.A }) })
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader('cart-loader'));
        dispatch(setGSTSavedProfiles(response?.gstProfiles));
        return cb?.(response);
      })
      .catch(error => {
        dispatch(hideLoader('cart-loader'));
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          cb?.(errorObj?.errorMessage);
        });
      });
  };
}

export function deleteGSTProfileUAAS(payload = {}, cb) {
  const { gstId = '' } = payload;
  const requestBody = { gstId };

  return dispatch => {
    dispatch(showLoader('cart-loader'));
    const apiEndPoint = '/api/cart/deleteGst';
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(requestBody)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader('cart-loader'));
        if (response?.status === 'SUCCESS') {
          dispatch(
            getGSTSavedProfiles({ reqOriginNode: false }, () => {
              return cb?.(response);
            })
          );
        } else {
          return cb?.(response);
        }
      })
      .catch(error => {
        dispatch(hideLoader('cart-loader'));
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          cb?.(errorObj?.errorMessage);
        });
      });
  };
}

// TODO-GST remove this api, as cart will call internally, not for ui
export function verifyPanUAAS(payload) {
  const {
    gstNumber = '',
    businessName = '',
    address = {},
    pan = '',
    dateOfIncorporation = ''
  } = payload;
  const requestBody = { gstNumber, businessName, address, pan, dateOfIncorporation };

  return dispatch => {
    dispatch(showLoader('cart-loader'));
    const apiEndPoint = '/api/cart/verifyPan';
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(requestBody)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader('cart-loader'));
        return response;
      })
      .catch(() => {
        dispatch(setErrorObject('Something Went Wrong'));
        dispatch(hideLoader('cart-loader'));
      });
  };
}
